import { render, staticRenderFns } from "./idb.vue?vue&type=template&id=847518d8&"
import script from "./idb.vue?vue&type=script&lang=js&"
export * from "./idb.vue?vue&type=script&lang=js&"
import style0 from "./idb.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports